<template>
    <div>
        <a-icon type="double-right" class="mr-2 text-danger" />
        <span class="companyName"><strong>{{ String($store.state.AppActiveCompany.name).toUpperCase() }}</strong></span> | <span class="roleName"> {{ String(roleName($store.state.AppActiveUser.role)).toUpperCase() }} </span>
    </div>
</template>

<script>
    import AvailableRoles from '@/components/role/roles.js'

    export default {
        data () {
            return {

            }
        },

        methods : {
            roleName (roleId) {
                return AvailableRoles.getRoleName(roleId)
            }
        }
    }
</script>

<style>
    .arrowIcon {
        top: 10px;
    }

    .companyName {
        text-decoration: underline;
    }
</style>